import { render, staticRenderFns } from "./WhatIs.vue?vue&type=template&id=0f829244&"
import script from "./WhatIs.vue?vue&type=script&lang=js&"
export * from "./WhatIs.vue?vue&type=script&lang=js&"
import style0 from "./WhatIs.vue?vue&type=style&index=0&id=0f829244&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports